require('./bootstrap');

import Vue from 'vue';
window.Vue = Vue;

// Registrar componentes aquí
Vue.component('example-component', require('./components/ExampleComponent.vue').default);

// Esperamos al DOM para no tener el error de #app
document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('app')) {
        new Vue({
            el: '#app',
        });
    }
});
